import React from 'react';
import Select from 'react-select';

const FILTER_CONFIG = {
  paymentGateway: {
    label: "Payment Gateway",
    render: ({ filters, dropdowns, onFilterChange }) => (
      <div className="col-md-3">
        <label className="form-label small mb-1">Payment Gateway</label>
        <Select
          options={dropdowns.paymentGateways || [
            { value: 'offline', label: 'Offline' },
            { value: 'online', label: 'Online' }
          ]}
          value={(dropdowns.paymentGateways || []).find(opt => opt.value === filters.paymentGateway) || null}
          onChange={selected => onFilterChange('paymentGateway', selected ? selected.value : '')}
          placeholder="Payment Gateway"
          isClearable
          classNamePrefix="react-select"
        />
      </div>
    ),
  },
  plan: {
    label: "Select Plan",
    render: ({ filters, dropdowns, onFilterChange }) => (
      <div className="col-md-3">
        <label className="form-label small mb-1">Select Plan</label>
        <Select
          options={dropdowns.plans || [
            { value: 'basic', label: 'Basic' },
            { value: 'premium', label: 'Premium' }
          ]}
          value={(dropdowns.plans || []).find(opt => opt.value === filters.plan) || null}
          onChange={selected => onFilterChange('plan', selected ? selected.value : '')}
          placeholder="Select Plan"
          isClearable
          classNamePrefix="react-select"
        />
      </div>
    ),
  },
  duration: {
    label: "Duration",
    render: ({ filters, dropdowns, onFilterChange }) => (
      <div className="col-md-3">
        <label className="form-label small mb-1">Duration</label>
        <Select
          options={dropdowns.durations || [
            { value: 'last_week', label: 'Registered In Last 1 Week' },
            { value: 'last_month', label: 'Registered In Last 1 Month' },
            { value: 'all', label: 'All Time' },
          ]}
          value={(dropdowns.durations || []).find(opt => opt.value === filters.duration) || null}
          onChange={selected => onFilterChange('duration', selected ? selected.value : '')}
          placeholder="Duration"
          isClearable
          classNamePrefix="react-select"
        />
      </div>
    ),
  },
  companyStatus: {
    label: "Company Status",
    render: ({ filters, dropdowns, onFilterChange }) => (
      <div className="col-md-3">
        <label className="form-label small mb-1">Company Status</label>
        <Select
          options={dropdowns.companyStatuses || [
            { value: 'Licensed Expired', label: 'Licence Expired' },
            { value: 'Trial Expired', label: 'Trial Expired' },
            { value: 'New', label: 'New' }
          ]}
          value={(dropdowns.companyStatuses || []).find(opt => opt.value === filters.companyStatus) || null}
          onChange={selected => onFilterChange('companyStatus', selected ? selected.value : '')}
          placeholder="Company Status"
          isClearable
          classNamePrefix="react-select"
        />
      </div>
    ),
  },
  status: {
    label: "Status",
    render: ({ filters, dropdowns, onFilterChange }) => (
      <div className="col-md-3">
        <label className="form-label small mb-1">Status</label>
        <Select
          options={dropdowns.statuses || [
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' }
          ]}
          value={(dropdowns.statuses || []).find(opt => opt.value === filters.status) || null}
          onChange={selected => onFilterChange('status', selected ? selected.value : '')}
          placeholder="Status"
          isClearable
          classNamePrefix="react-select"
        />
      </div>
    ),
  },
  city: {
    label: "City",
    render: ({ filters, dropdowns, onFilterChange }) => (
      <div className="col-md-3">
        <label className="form-label small mb-1">City</label>
        <Select
          options={dropdowns.cities || []}
          value={(dropdowns.cities || []).find(opt => opt.value === filters.cityId) || null}
          onChange={selected => onFilterChange('cityId', selected ? selected.value : '')}
          placeholder="City"
          isClearable
          classNamePrefix="react-select"
        />
      </div>
    ),
  },
  state: {
    label: "State",
    render: ({ filters, dropdowns, onFilterChange }) => (
      <div className="col-md-3">
        <label className="form-label small mb-1">State</label>
        <Select
          options={dropdowns.states || []}
          value={(dropdowns.states || []).find(opt => opt.value === filters.stateId) || null}
          onChange={selected => onFilterChange('stateId', selected ? selected.value : '')}
          placeholder="State"
          isClearable
          classNamePrefix="react-select"
        />
      </div>
    ),
  },
  country: {
    label: "Country",
    render: ({ filters, dropdowns, onFilterChange }) => (
      <div className="col-md-3">
        <label className="form-label small mb-1">Country</label>
        <Select
          options={dropdowns.countries || []}
          value={(dropdowns.countries || []).find(opt => opt.value === filters.countryId) || null}
          onChange={selected => onFilterChange('countryId', selected ? selected.value : '')}
          placeholder="Country"
          isClearable
          classNamePrefix="react-select"
        />
      </div>
    ),
  },
  dateRange: {
    label: "Date Range",
    render: ({ filters, onFilterChange }) => (
      <div className="col-md-4">
        <label className="form-label small mb-1">Date Range</label>
        <div className="d-flex gap-2">
          <input
            type="date"
            className="form-control"
            value={filters.startDate || ''}
            onChange={e => onFilterChange('startDate', e.target.value)}
          />
          <span className="align-self-center" style={{ fontSize: 13 }}>to</span>
          <input
            type="date"
            className="form-control"
            value={filters.endDate || ''}
            onChange={e => onFilterChange('endDate', e.target.value)}
          />
        </div>
      </div>
    ),
  },
};

const CommanFilters = ({
  filters,
  dropdowns = {},
  onFilterChange,
  onApplyFilters,
  onClearFilters,
  fields = [
    'paymentGateway',
    'plan',
    'duration',
    'companyStatus',
    'status',
    'city',
    'state',
    'country',
    'dateRange'
  ],
}) => {
  return (
    <div
      className="card p-4 mb-3"
      style={{ 
        border: '1px solid #e3e6ef',
        borderRadius: '8px',
        
        margin: 'auto'
      }}
    >
      <div className="mb-3">
        <span className="h5 fw-bold" style={{ color: '#222' }}>Filter by</span>
      </div>
      <form
        className="row gx-3 gy-2 align-items-center"
        onSubmit={e => {
          e.preventDefault();
          if (onApplyFilters) onApplyFilters();
        }}
      >
        {fields.map(field =>
          FILTER_CONFIG[field] &&
          FILTER_CONFIG[field].render({ filters, dropdowns, onFilterChange })
        )}

        <div className="col-12 mt-4 d-flex justify-content-center gap-2">
          <button
            className="btn btn-primary"
            type="submit"
            style={{ minWidth: 120, borderRadius: "6px" }}
          >
            Apply Filter
          </button>
          <button
            className="btn btn-secondary"
            type="button"
            style={{ minWidth: 120, borderRadius: "6px" }}
            onClick={onClearFilters}
          >
            Clear
          </button>
        </div>
      </form>
    </div>
  );
};

export default CommanFilters;